import type { SiteConfig } from '../../@types/context/site-config.types';
import { serviceTrustpilotAxoConfig } from './service-trustpilot-axo.config';

export const serviceTrustpilotAxoSeConfig: SiteConfig['services']['trustpilot'] =
  {
    ...serviceTrustpilotAxoConfig,
    businessUnitId: '548ebd7e00006400057c2904',
  };
